(function () {
  function initSection(section) {
    if (!section || section.dataset.revealInit === "true") return;
    section.dataset.revealInit = "true";

    const targets = section.querySelectorAll(".reveal, .reveal-stagger");

    if (!("IntersectionObserver" in window)) {
      targets.forEach((el) => el.classList.add("is-visible"));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -80px 0px" }
    );

    targets.forEach((el) => io.observe(el));
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll(".section-mecanismo-v2").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });
})();
